/**
 * SIM-1724 — inline edit form for a single skill row (T2 atomic-save UX). Controlled by the
 * parent's staged-draft reducer: every keystroke calls `onChange` with a field patch, so there is
 * no local form state to fall out of sync with the batch. The shared Reason lives on the SaveBar.
 */
import { Input, Label, Textarea } from "@simplicity/ui";
import type { SkillFields } from "./skillsDraft";

interface SkillEditFormProps {
  idPrefix: string;
  fields: SkillFields;
  onChange: (patch: Partial<SkillFields>) => void;
}

export function SkillEditForm({ idPrefix, fields, onChange }: SkillEditFormProps) {
  return (
    <div className="space-y-3 rounded-md border border-border bg-muted/20 p-3">
      <div className="space-y-1">
        <Label htmlFor={`${idPrefix}-name`}>Name</Label>
        <Input
          id={`${idPrefix}-name`}
          value={fields.name}
          onChange={(e) => onChange({ name: e.target.value })}
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor={`${idPrefix}-description`}>Description</Label>
        <Textarea
          id={`${idPrefix}-description`}
          rows={2}
          value={fields.description}
          onChange={(e) => onChange({ description: e.target.value })}
        />
      </div>
      <div className="space-y-1">
        <Label htmlFor={`${idPrefix}-body`}>Body (markdown)</Label>
        <Textarea
          id={`${idPrefix}-body`}
          rows={8}
          value={fields.body}
          onChange={(e) => onChange({ body: e.target.value })}
        />
      </div>
    </div>
  );
}
